import { useEffect, useState } from "react";
import { NotificationModal } from "./notificationModal";
import ReactFlagsSelect from "react-flags-select";
import { useNavigate } from "react-router-dom";
import { useLocalStorageSync } from "../hooks/useLocalStorageSync";
import { useDispatch } from "react-redux";
import { logoutQA } from "../../reducers/qualityAlertSlice";

export function Header({ pageTitle }: any) {
  const navigate = useNavigate();
  //let notifications:any[] = [];
  //let unReadNotifications = 0;
  const [modalOn, setModal] = useState(false);
  const [dropdownOn, setDropdown] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unReadNotifications, setUnReadNotifications] = useState(0);
  const [selected, setSelected] = useState("US");
  const [profilePicture, setProfilePicture] = useState("");
  const dispatch = useDispatch();

  const [initialProfilePictureLoad, setInitialProfilePictureLoad] =
    useState(false);
  const [syncCounter, refreshLocalStorage] = useLocalStorageSync();

  const processNav = (path: string) => {
    setDropdown(false);
    navigate(path);
  };

  function toggleModal() {
    setModal(!modalOn);
  }

  function toggleDropdown() {
    setDropdown(!dropdownOn);
  }

  function onLangChange(code: string) {
    setSelected(code);
    localStorage.setItem("selectedLang", code);
  }
  useEffect(() => {
    const updatedProfilePicture = localStorage.getItem("ProfilePicture") || "";
    setProfilePicture(updatedProfilePicture);
    setInitialProfilePictureLoad(true);
  }, [syncCounter]);

  function getProfilePicture() {
    const pfp = localStorage.getItem("ProfilePicture");

    if (pfp) {
      setProfilePicture(pfp.replace(/"/g, ""));
    } else {
      setProfilePicture("");
    }

    setInitialProfilePictureLoad(true);
  }

  const logout = () => {
    // Remove specific items from local storage
    localStorage.removeItem("auth_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("selected_supplier");
    localStorage.removeItem("selected_producting_facilities");
    localStorage.removeItem("ProfilePicture");

    // Collect keys to remove
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("qualityAlerts")) {
        keysToRemove.push(key);
      }
    }

    // Remove the collected keys
    keysToRemove.forEach((key) => localStorage.removeItem(key));

    // Reset state and navigate to login page
    dispatch(logoutQA());

    setDropdown(false);
    navigate("/login");
  };

  const openMail = () => {
    var body = `Hello! I\'m inviting you to Qnet by Team Quality Services, a tool that brings real-time information from your on-site liaisons to the palm of your hand. `;
    body += `Click here to download the Qnet app from the App Store: https://apps.apple.com/us/app/qnet-by-team-quality-services/id1595922135`;
    setDropdown(false);

    location.href = `mailto:?subject=Qnet™ by TQS: Real-Time Quality Information&body=${body}`;
  };

  return (
    <div className="ml-[5vw] flex h-[85px] w-[95vw] content-center items-center bg-[#f6f6f6] p-[16px] pl-[1%] pt-[40px] max-[600px]:h-[170px] max-[600px]:flex-wrap max-[600px]:justify-between">
      {/* Section #1 */}
      <div className="flex w-[49%] content-center max-[600px]:w-[50%]">
        <h1
          className={`text-4xl font-semibold text-[#212322] ${pageTitle === "Analytics" || pageTitle === "Your Teams" || pageTitle === "Account Settings" ? "ml-20" : ""}`}
        >
          {pageTitle}
        </h1>{" "}
      </div>
      {/* Section #2 */}
      {/* <div className="w-[33%] max-[600px]:order-[3] max-[600px]:w-[100%]">
        <div className="flex h-[100%] flex-wrap content-center justify-center">
          <label className="input flex max-h-[40px] w-[100%] max-w-[500px] items-center gap-2 bg-[#eff0f0] text-[#212322] focus-within:outline-none focus:outline-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="currentColor"
              className="h-4 w-4 opacity-70"
            >
              <path
                fillRule="evenodd"
                d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
                clipRule="evenodd"
              />
            </svg>
            <input type="text" className="grow" placeholder="Search" />
          </label>
        </div>
      </div> */}
      {/* Section #3 */}
      <div className="flex w-[50%] flex-wrap content-center items-center justify-end gap-[20px] max-[600px]:w-[50%]">
        <div className="mr-[10px] flex items-center rounded-full bg-[#EFF0F0] px-[2px]">
          {/* <ReactFlagsSelect
            className="!pb-0"
            selectButtonClassName="!p-[3px] !border-0 "
            countries={["US", "ES", "FR", "DE"]}
            customLabels={{ US: " ", ES: " ", FR: " ", DE: " " }}
            selected={selected}
            onSelect={(code) => onLangChange(code)}
            showSelectedLabel={false}
          /> */}
        </div>
        {/* <div className="relative cursor-pointer">
          <FontAwesomeIcon
            icon={faBell}
            onClick={() => toggleModal()}
            className="text-[20px] text-[grey]"
          />
          <div className="absolute right-[11px] top-[-4px] rounded-lg bg-[#ff453a] px-[4px] py-[2px] text-[8px]">
            {unReadNotifications}
          </div>
        </div> */}
        <div className="relative">
          {profilePicture ? (
            <div
              className="h-[40px] w-[40px] rounded-full bg-cover bg-center"
              style={{ backgroundImage: `url(${profilePicture})` }}
              role="img"
              aria-label={`profile picture: ${profilePicture}`}
            >
              <img
                src={profilePicture}
                alt="Profile Picture"
                className="h-[40px] w-[40px] rounded-full bg-cover bg-center"
                onError={(e) => {
                  (e.target as any).src = "/dashboard/avatar.png"; // Fallback to Avatar if profilePicture fails
                  (e.target as any).style.display = "block"; // Ensure fallback is visible

                  if ((e.target as any)?.target) {
                    (
                      e.target as any
                    ).target.parentElement.style.backgroundImage = "none"; // Remove background image
                  }
                }}
                style={{ display: "none" }} // Hide img since background image is used
              />
            </div>
          ) : initialProfilePictureLoad ? (
            <img
              className="h-[40px] w-[40px] rounded-full bg-cover bg-center"
              src="/dashboard/avatar.png"
              alt="Default Profile Picture"
            />
          ) : (
            <img
              className="h-[40px] w-[40px] rounded-full bg-cover bg-center"
              src="/dashboard/loading-sm.gif"
              alt="Loading Profile Picture"
            />
          )}
          {dropdownOn && (
            <div className="absolute right-[0] top-[50px] z-[99] text-[#212322]">
              <div
                onClick={() => processNav("/settings")}
                className="cursor-pointer whitespace-nowrap border-b-[1px] border-[#c4c2c2] bg-[#ffffff] px-[25px] py-[10px] transition-all hover:bg-[#c4c2c2]"
              >
                Account Settings
              </div>
              <div
                onClick={() => openMail()}
                className="cursor-pointer whitespace-nowrap border-b-[1px] border-[#c4c2c2] bg-[#ffffff] px-[25px] py-[10px] transition-all hover:bg-[#c4c2c2]"
              >
                Invite Others
              </div>
              <div
                onClick={() => logout()}
                className="cursor-pointer whitespace-nowrap border-b-[1px] border-[#c4c2c2] bg-[#ffffff] px-[25px] py-[10px] transition-all hover:bg-[#c4c2c2]"
              >
                Log Out
              </div>
            </div>
          )}
        </div>
      </div>
      {modalOn && (
        <div
          className="absolute left-0 top-0 z-50 flex h-screen w-screen items-center justify-center bg-[#21232260]"
          onClick={() => toggleModal()}
        >
          <NotificationModal />
        </div>
      )}
    </div>
  );
}
